<template>
  <div
    id="audio-component"
    ref="audioPlay"
  >
    <!--音频组件-->
    <div
      v-show="autoLoad"
      id="audio-box"
      :class="'no-bg'"
      :style="{left: pos.left + 'px', top: pos.top + 'px'}"
    >
      <!--资源不存等错误信息-->
      <div
        v-show="prompt"
        class="message-cover"
      >
        <div class="message-error">
          <div class="message">
            <svg class="item-icon">
              <use xlink:href="#loadFail" />
            </svg>
            <p class="m-title">
              {{ $t('Emm...音频加载失败') }}
            </p>
            <div class="m-content">
              <p>{{ $t('我们也不希望看到这种情况，请您检查:') }}</p>
              <p>{{ `1.${$t('网络链接是否正常')}` }}</p>
              <p>{{ `2.${$t('音频文件是否损坏')}` }}</p>
            </div>
          </div>
          <button
            class="operation"
            @click="reGetVideoResource"
          >
            {{ $t('重试') }}
          </button>
        </div>
      </div>

      <!-- 资源加载提示信息 -->
      <div
        v-show="showLoading"
        class="message-cover"
      >
        <div class="loading" />
      </div>

      <!-- 资源转码 -->
      <div
        v-show="transcoding"
        class="message-cover"
      >
        <img
          src="./image/color-bounce-white.gif"
          class="transcoding"
        >
        <div class="message-trans">
          {{ $t('音频转码中，请耐心等待') }}
        </div>
      </div>

      <!-- 视频转码提示信息 -->
      <div
        v-show="transError"
        class="message-cover"
      >
        <div class="message-warn">
          <div class="message">
            {{ $t('音频正在转码，暂时无法播放，请稍后重试') }}
          </div>
          <button
            class="operation"
            @click="reGetVideoResource"
          >
            {{ $t('重试') }}
          </button>
        </div>
      </div>

      <!--声音组件-->
      <div
        v-if="hasResource"
        class="blank"
      >
        <div class="music-visiable-start" />
      </div>
      <audioContent
        v-if="hasResource"
        :video-options="videoOptions"
        :language="language"
        @audioPause="audioPause"
        @audioPlay="audioPlay"
      />
    </div>
  </div>
</template>

<script>
import * as Util from 'js/util/util'

const { jsonp, getData } = require('js/api/getdata').default

const audioContent = () => import('components/common/audio/index.vue')

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    language: {
      type: String,
      default: Util.getLanguage(),
    },
    autoLoad: {
      type: Boolean,
      default: true,
    },
    previewHandler: {
      type: Object,
      default: null,
    },
  },
  components: {
    audioContent,
  },
  data() {
    return {
      pos: {
        left: 0,
        top: 0,
      },
      isAudio: true, // 是否为音频
      showLoading: true, // 资源加载中
      transcoding: false, // 是否需要编译
      transError: false, // 编译失败
      hasResource: false, // 资源是否存在
      prompt: '', // 提示信息
      videoOptions: { // 视频资源加载配置
        autoplay: true,
        controls: true,
        inactivityTimeout: 0,
        controlBar: { // 设置控制条组件 /* 设置控制条里面组件的相关属性及显示与否*/
          currentTimeDisplay: true,
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          volumePanel: {
            inline: false,
          },
        },
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],
      },
      reqTime: '', // 转码请求时间
      reqInterval: '', // 转码回调
    }
  },
  mounted() {
    // 设置位置
    this.setPosition()
    window.addEventListener('resize', this.setPosition)
  },
  destroyed() {
    window.removeEventListener('resize', this.setPosition)
  },
  methods: {
    previewDone(data) {
      // 返回请求地址
      this.videoOptions.sources['0'].src = data.stat_url
      this.hasResource = true
      this.showLoading = false
      this.transcoding = false
      this.transError = false
      this.prompt = false
      this.setPosition()
    },
    previewFail() {
      this.isVideo = false
      this.showLoading = false
      this.transcoding = false
      this.transError = false
      this.prompt = true
    },
    progressCallback(progressData) {
      if (progressData.result === 'converting') { // 视频的转码轮询过程
        // 显示转码
        this.transcoding = true
        this.showLoading = false
        this.transError = false
        this.prompt = false
        if (this.reqTime === '') {
          this.reqTime = Date.parse(new Date())
        } else if (Date.parse(new Date()) - this.reqTime >= 6000) {
          this.previewHandler.stopProgress() // 停止循环查询
          this.$nextTick(() => {
            this.reqTime = ''
            this.reqInterval = ''
            this.hasResource = false
            this.showLoading = false
            this.transError = true
            this.transcoding = false
            this.prompt = false
          })
        }
      }
    },
    reGetVideoResource() {
      this.transError = false
      this.showLoading = true
      this.$emit('reGetData')
    },
    /**
             * 暂停的回调
             */
    audioPause() {
      document.querySelector('.music-visiable').className = 'music-visiable-start'
    },
    /** 播放的回调 */
    audioPlay() {
      document.querySelector('.music-visiable-start').className = 'music-visiable'
    },
    // 文件切换预处理
    startPreview(meteData) {
      this.showLoading = true
      this.hasResource = false
      if (meteData) {
        this.data = meteData
        this.autoLoad = true
      }
    },
    /**
             * 根据data数据解析相应的播放视频资源
             */
    getAudioResource() {
      // 隐藏提示框(重试)
      this.transError = false
      // 销毁异常提示
      this.prompt = false

      // 判断data资源是否正确 //判断是否为音频资源
      if (Object.keys(this.data).length <= 0 || this.data.mime_type.indexOf('audio') === -1) {
        this.isAudio = false
        this.showLoading = false
        this.transcoding = false
        this.transError = false
        this.prompt = true
      }
      const params = {
        neid: this.data.neid,
        hash: this.data.hash,
        rev: this.data.rev,
        delivery_code: this.data.delivery_code,
        account_id: -1,
        uid: -1,
      }

      getData('deliveryAvStat', params).then((res) => {
        if (res.data.state === 200) {
          this.videoOptions.sources['0'].src = `${this.data.preview_url}&token=${this.data.token}`
          this.hasResource = true
          this.showLoading = false
          this.transcoding = false
          this.transError = false
          this.prompt = false
        }
      })
      // // 组合请求参数
      // const params = {
      //   path: this.data.path,
      //   path_type: this.data.path_type,
      //   from: this.data.from || '',
      //   neid: this.data.neid,
      //   prifix_neid: this.data.prifix_neid || '',
      //   rev: this.data.rev || '',
      //   type: this.data.type || 'av',
      //   root: this.data.root || 'ent',
      //   _: Date.parse(new Date()),
      // }
      //
      // // 转化path
      // const encodePath = encodeURIComponent(params.path)
      // // 设置共有url部分
      // const baseUrl = `path=${encodePath
      // }&path_type=${params.path_type}&from=${params.from}&neid=${params.neid
      // }&prifix_neid=${params.prifix_neid}&rev=${params.rev}&type=${params.type
      // }&root=${params.root}&hash=${this.data.hash}`
      //
      // // 请求数据
      // jsonp(`/v2/video_stat?${baseUrl}`, 'callback', (res) => {
      //   if (res.data && res.data.code === 200) {
      //     // 组合请求url
      //     const src = Util.encodePath(`/v2/preview_router?${baseUrl}&_=${params._}&interface_version=2020`)
      //     // 校验资源
      //     getData(`${src}&probe=1`).then(() => {
      //       // 返回请求地址
      //       this.videoOptions.sources['0'].src = src
      //       this.hasResource = true
      //       this.showLoading = false
      //       this.transcoding = false
      //       this.transError = false
      //       this.prompt = false
      //     }).catch((err) => {
      //       if (err.response && err.response.status === 403) {
      //         // 关闭循环
      //         clearInterval(this.reqInterval)
      //         this.reqTime = ''
      //         this.reqInterval = ''
      //         // 提示
      //         this.showLoading = false
      //         this.transcoding = false
      //         this.transError = false
      //         this.prompt = true
      //       }
      //     })
      //   } else {
      //     if (res.data.code === 'transcoding') { // 视频的转码轮询过程
      //       // 显示转码
      //       this.transcoding = true
      //       this.showLoading = false
      //       this.transError = false
      //       this.prompt = false
      //
      //       // 记录请求的当前时间
      //       if (this.reqTime === '') {
      //         this.reqTime = Date.parse(new Date())
      //       }
      //       if (this.reqInterval === '') {
      //         this.reqInterval = setInterval(() => {
      //           if (Date.parse(new Date()) - this.reqTime < 30000) {
      //             if (this.videoOptions.sources['0'].src !== '') {
      //               clearInterval(this.reqInterval)
      //               this.reqTime = ''
      //               this.reqInterval = ''
      //               return
      //             }
      //             this.getAudioResource()
      //           } else {
      //             clearInterval(this.reqInterval)
      //             this.reqTime = ''
      //             this.reqInterval = ''
      //             // 添加提示信息
      //             this.hasResource = false
      //             this.showLoading = false
      //             this.transError = true
      //             this.transcoding = false
      //             this.prompt = false
      //           }
      //         }, 6000)
      //       }
      //       return
      //     }
      //     // console.log(res.data.message);
      //     // 关闭循环
      //     clearInterval(this.reqInterval)
      //     this.reqTime = ''
      //     this.reqInterval = ''
      //
      //     // 返回提示信息
      //     this.hasResource = false
      //     this.showLoading = false
      //     this.transError = false
      //     this.transcoding = false
      //     this.prompt = true
      //   }
      // })
    },
    /**
             * 设置显示位置
             */
    setPosition() {
      // let boxWidth = document.querySelector('#audio-box').clientWidth;
      // this.pos.left = (this.$refs.audioPlay.clientWidth - boxWidth) / 2;
      const boxheight = document.querySelector('#audio-box').clientHeight
      this.pos.top = (this.$refs.audioPlay.clientHeight - boxheight) / 2
    },
  },
}
</script>

<style lang="less" scoped>
#audio-component {
  height:100%;
  width:100%;
  background-color: #F6F7FA;

  #audio-box {
    position: relative;
    margin: auto;
  }

  .blank{
    width:100%;
    height: 100%;
    background: #000000;
    position: absolute;
  }

  .music-visiable-start, .music-visiable {
    width:100%;
    height: 100%;
    background: #000000;
    position: absolute;
  }

  @media screen and (min-width: 1024px) {
    #audio-box {
      width: 730px;
      height: 184px;
    }

    .music-visiable-start {
      width:100%;
      height: 100%;
      background: #000000;
      position: absolute;
      background-size: 730px 184px;
    }

    .music-visiable {
      width:100%;
      height: 100%;
      position: absolute;
      background: url(./image/audio.gif) no-repeat;
      background-size: 730px 184px;
    }
  }

  @media screen and (max-width: 1024px) {
    #audio-box {
      width: 650px;
      height: 164px;
    }

    .music-visiable-start {
      width:100%;
      height: 100%;
      background: #000000;
      position: absolute;
      background-size: 650px 164px;
    }

    .music-visiable {
      width:100%;
      height: 100%;
      position: absolute;
      background: url(./image/audio.gif) no-repeat;
      background-size: 650px 164px;
    }
  }

  /**视频异常提示 */
  .message-error {
    text-align: center;
    width: 100%;
    position: absolute;
    top: -30%;
    margin: 0px;
    font-size: 14px;
    color: #1b2733;
    letter-spacing: 0;
    z-index: 0;

    .message{
      margin-bottom:20px;
      .m-title{
        margin-bottom:8px;
      }
      .m-content{
        margin-bottom:20px;
      }
    }

    .operation{
      outline: none;
      width:80px;
      height:32px;
      font-size: 14px;
      color: #FFFFFF;
      background: #0A64FA;
      border:1px solid #0A64FA;
      border-radius: 2px;
      cursor: pointer;
    }
  }


  /**视频转码警告 */
  .message-warn {
    text-align: center;
    width: 100%;
    position: absolute;
    top: 40%;
    margin: 0px;
    font-size: 14px;
    color: #1b2733;
    letter-spacing: 0;
    z-index: 0;
    .message{
      margin-bottom:20px;
    }
    .operation{
      outline: none;
      width:80px;
      height:32px;
      font-size: 14px;
      color: #1b2733;
      border: 1px solid #1B2733;
      border-radius: 2px;
      cursor: pointer;
    }
  }

  /**音频转码过程中的loading */
  .transcoding{
    width: 50px;
    height: 50px;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -25px;
    position: absolute;
    z-index: 0;
  }

  /**视频转码过程 */
  .message-trans{
    color: #1b2733;
    text-align: center;
    width: 100%;
    position: absolute;
    top: 60%;
    padding-top: 24px;
    margin: 0px;
    z-index: 0;
  }

  /**资源加载 */
  .loading{
    width: 60px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -30px 0 0 -30px;
    z-index: 0;
    background: url(./image/search-load.gif) no-repeat;
    background-size:60px 60px;
  }

  .no-bg{
    background: none!important;
  }
}

.item-icon {
  height: 130px;
  width: 130px;
}
</style>
